<template>
	<div>
		<v-btn x-small icon :disabled="focuses.length == 1" @click="changeFocus"><v-icon v-text="icon" x-small class="mr-2"></v-icon></v-btn>
		<v-icon v-for="color in colors" :key="color" :color="color" @click="setColor(color)" v-text="value == color ? 'mdi-square' : 'mdi-square-outline'"></v-icon>
	</div>
		
</template>

<script>
	export default {
		name: "EditorColours",
		props: {
			values: {type: Object}
		},
		data: () => {
			return {
				value: '',
				focus: '',
				colors: ["white", "grey", "primary", "green", "accent", "red", "black"]
			}
		},
		computed: {
			focuses() {
				return Object.keys(this.values);
			},
			icon(){
				if( this.focus == "text" ){
					return "mdi-format-text-variant"
				}
				if( this.focus == "background" ){
					return "mdi-format-paint"
				}
				if( this.focus == "title" ){
					return "mdi-format-title"
				}
				return "mdi-format-paint"
			}
		}, 
		watch: {
			focus: {
				immediate: true, 
				handler(){
					this.value = this.values[this.focus]
				}
			}
		},
		methods: {
			changeFocus(){
				var i = this.focuses.indexOf( this.focus ) 
				i++;
				if( i == this.focuses.length ){
					i = 0;
				}
				this.focus = this.focuses[i]
			},
			setColor(color){
				if( color == 'grey' ){
					color = "#F5F5F5"
				}
				this.$emit("change", this.focus, color)
			}
		}, 
		created(){
			this.focus = Object.keys(this.values)[0]
		}
	}
</script>